module.exports = __webpack_public_path__ + "img/zhilingkongzhi.a494d7d1.png";